import React from "react"
import {DefaultProps, RefTable, Validator} from "../RefTable";

export const AnnualFees = (props)=><RefTable {...props}/>;

AnnualFees.defaultProps = {
    ...DefaultProps,
    title: "Annual Fees",
    tableSchema: "em_annual_fee_type",
    tableName: "em_annual_fee_type",
    edit: true,
    validator: {
        value: new Validator("value", async (value)=> {
            if(value < 0 )
                return Promise.reject("Duty cannot be negative")
        })
    },
}
